import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
import { ContentFragmentType } from '../content/contentBuilder/Content';
export const convertInteractiveProcessWidgetToServerModel = (widget) => {
    const assetIds = [];
    const assetAlignments = [];
    const texts = [];
    const titles = [];
    for (const value of widget.value.data.slides) {
        assetIds.push(value.assetId);
        assetAlignments.push(value.assetAlignment);
        texts.push(value.text);
        titles.push(value.title);
    }
    return {
        id: widget._id,
        trackingIdentifier: widget.trackingIdentifier,
        type: WidgetType.interactiveProcess,
        data: {
            assets: assetIds,
            assetAlignments,
            texts,
            titles,
        },
        properties: {
            displayDelayInSeconds: widget.value.properties.displayDelayInSeconds,
            isRequired: widget.value.properties.isRequired,
        },
    };
};
export const convertInteractiveProcessFromServerModel = (serverModel) => {
    var _a, _b, _c, _d;
    const dataKeys = ['titles', 'texts', 'assets', 'assetAlignments'];
    const dataLengths = dataKeys.map((key) => serverModel.data[key].length);
    const slideCount = Math.max(...dataLengths);
    const areAllTheSame = dataLengths.every((length) => length === dataLengths[0]);
    if (!areAllTheSame) {
        console.warn('Widget has incorrect lengths of slide data arrays');
    }
    const slides = [];
    for (let i = 0; i < slideCount; i++) {
        const slide = {
            assetId: (_a = serverModel.data.assets[i]) !== null && _a !== void 0 ? _a : null,
            assetAlignment: (_b = serverModel.data.assetAlignments[i]) !== null && _b !== void 0 ? _b : null,
            text: (_c = serverModel.data.texts[i]) !== null && _c !== void 0 ? _c : null,
            title: serverModel.data.titles[i],
        };
        slides.push(slide);
    }
    return {
        _id: serverModel.id,
        type: ContentFragmentType.Widget,
        initialized: true,
        trackingIdentifier: serverModel.trackingIdentifier,
        value: {
            type: WidgetType.interactiveProcess,
            data: {
                slides,
            },
            properties: {
                isRequired: (_d = serverModel.properties.isRequired) !== null && _d !== void 0 ? _d : false,
                displayDelayInSeconds: serverModel.properties.displayDelayInSeconds,
            },
        },
    };
};
